import { Pipe, PipeTransform } from '@angular/core'

import { UtilityService } from '@core/services/utility.service'
import dayjs from 'dayjs'
import { TranslateService } from '@ngx-translate/core'
import { isInteger } from 'lodash-es'

@Pipe({
  name: 'dayjsDuration',
  standalone: false,
})
export class DayjsDurationPipe implements PipeTransform {
  constructor(private utilityService: UtilityService) {}

  transform(durationSec: number | string): string {
    return this.utilityService.dayjsDuration(durationSec)
  }
}

@Pipe({
  name: 'dayjsDurationInHours',
  standalone: false,
})
export class DayjsDurationInHoursPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(durationSec: number | string): string {
    const durationValue = dayjs.duration(Number(durationSec), 'seconds')
    const durationInHours = durationValue.asHours()
    const fixedInHours = isInteger(durationInHours) ? durationInHours : +durationInHours.toFixed(durationInHours > 1000 ? 1 : 2)
    return this.translateService.instant('ABBREVIATIONS.H', { value: fixedInHours }) as string
  }
}
